const e = "Kaldır", o = {
  remove: e
};
export {
  o as default,
  e as remove
};
